import React from "react";
import type { TopBarConfig, LogoConfig } from "../../types/config";
import "./styles/style.css";

type TopBarProps = TopBarConfig & { slot?: string; style?: React.CSSProperties };

const TopBar: React.FC<TopBarProps> = (props) => {
  const Logo = (logo?: LogoConfig) => {
    if (!logo?.src) return null;

    // Use configured dimensions if provided, otherwise fit within container
    const logoStyle: React.CSSProperties = {
      height: logo.height ? `${logo.height}px` : '100%',
      width: logo.width ? `${logo.width}px` : '100%',
      maxWidth: '100%',
      objectFit: 'contain',
      ...(logo.style || {}),
    };

    const img = (
      <img
        src={logo.src}
        alt={logo.alt || ""}
        className="top-bar-logo"
        style={logoStyle}
      />
    );
    return logo.href ? (
      <a 
        href={logo.href} 
        target="_blank" 
        rel="noreferrer noopener" 
        className="top-bar-logo-link"
      >
        {img}
      </a>
    ) : (
      img
    );
  };

  return (
    <div
      slot={props.slot}
      className="top-bar-container"
      style={{
        backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : undefined,
        ...(props.style || {}),
      }}
    >
      {props.overlayColor && (
        <div
          aria-hidden
          className="top-bar-overlay"
          style={{
            backgroundColor: props.overlayColor,
            opacity: props.overlayOpacity ?? 0.35,
          }}
        />
      )}
      <div
        className="top-bar-content"
        style={{
          padding: `0 ${props.paddingX ?? 16}px`,
        }}
      >
        <div
          className="top-bar-left"
          style={{
            gap: props.gap ?? 16,
          }}
        >
          {Logo(props.leftLogo)}
          <div className="top-bar-text-container">
            {props.title && (
              <div className="top-bar-title">
                {props.title}
              </div>
            )}
            {props.subtitle && (
              <div className="top-bar-subtitle">
                {props.subtitle}
              </div>
            )}
          </div>
        </div>
        <div className="top-bar-right">{Logo(props.rightLogo)}</div>
      </div>
    </div>
  );
};

export default TopBar;